import {
  BatchStatementAndInvoices,
  PaginatedDebtorOrderHistories,
} from "types/model.types";
import { authApi } from "./";

const apiStatementPrefix = "statement";

export const processEOM = async (period: string): Promise<void> => {
  await authApi.post<void>(`${apiStatementPrefix}/processEOM`, { period });
};
export const processEOY = async (period: string): Promise<void> => {
  await authApi.post<void>(`${apiStatementPrefix}/processEOY`, { period });
};
export const createBatchEmail = async (): Promise<void> => {
  await authApi.post<void>(`${apiStatementPrefix}/createBatchEmail`, {});
};

export const getBatchEmail =
  async (): Promise<void | BatchStatementAndInvoices> => {
    const { data } = await authApi.post<BatchStatementAndInvoices>(
      `${apiStatementPrefix}/getBatchEmail`,
    );
    return data;
  };

export const getParentStatements = async (
  id: number,
): Promise<void | PaginatedDebtorOrderHistories> => {
  // CSV mode
  const response = await authApi.post(
    `${apiStatementPrefix}/downloadParentStatements`,
    {
      id,
    },
    { responseType: "blob" },
  );

  const blob = new Blob([response.data], { type: "text/csv" });
  const url = window.URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = `parent-debtor-statements-${id}.csv`;
  document.body.appendChild(link);
  link.click();
  link.remove();

  window.URL.revokeObjectURL(url);
  return;
};
